<template>	
	<select :disabled="disabled" v-model="selected">
		<option :value="null">-</option>
		<option 
		v-for="opcao in opcoes"
		:value="opcao.Id">{{ opcao.Referencia }}</option>
	</select>
</template>

<script>
	export default {
		props: ['value', 'opcoesPart', 'pergunta', 'disabled'],
		data() {
			return {
				opcoes: [],
				selected: null
			}
		},

		mounted() {
			this.selected = this.value
			this.fillOpcoes()
		},

		watch: {
			selected(v) {
				this.$emit('changed', v, this.pergunta.Id)
			}
		},

		methods: {
			fillOpcoes() {
				var opcoes = this.pergunta.Opcoes.map((o) => o)
				var refs = opcoes.map((o) => o.Referencia)


				this.opcoesPart.forEach((o) => {
					if(!refs.includes(o.Referencia)) {
						opcoes.push(o)
					}
				})

				this.opcoes = opcoes.sort((a, b) => this.compare(a, b))
			},

			compare(a, b) {
				const refA = a.Referencia.toUpperCase();
				const refB = b.Referencia.toUpperCase();

				let comparison = 0;
				if (refA > refB) {
					comparison = 1;
				} else if (refA < refB) {
					comparison = -1;
				}
				return comparison;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/ui/Select.vue